/* eslint-disable @typescript-eslint/no-explicit-any */
import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import { FormProvider, useForm } from 'react-hook-form';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { TextAreaInput } from 'components/Inputs/TextAreaInput';
import { requestPopUpTransFieldsTranslations } from './translations';
import { IModeratorRequestFormFields, RequestPopUpTransFields } from './types';
import styles from './requestPopUp.module.scss';
import { useThrottleFn } from 'hooks/useThrottleFn';

export const RequestPopUp = observer(function () {
  const {
    popUpStore: { closePopUp, title, description, buttonLabel, callBack },
  } = useStore();

  const { t } = useMyTranslations<RequestPopUpTransFields>([requestPopUpTransFieldsTranslations.name]);

  const useFormMethods = useForm<IModeratorRequestFormFields>();

  const {
    handleSubmit,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { errors }, // should create errors conts to update errors when they appears
  } = useFormMethods;

  const handleSave = useThrottleFn(({ adminMessage }: IModeratorRequestFormFields) => {
    callBack && callBack.cb(adminMessage);
  });

  return (
    <div className={styles.content}>
      <p className={styles.title}>{title || t('title')}</p>
      <p className={styles.desc}>{description}</p>
      <FormProvider {...(useFormMethods as any)}>
        <TextAreaInput name='adminMessage' placeholder='' required showRequiredIcon={false} autoFocus maxLength={255} />
      </FormProvider>
      <footer className={styles.footer}>
        <button type='reset' className={styles.btnReset} onClick={closePopUp}>
          {t('cancel')}
        </button>
        <button type='button' className={styles.btnSubmit} onClick={handleSubmit(handleSave)}>
          {buttonLabel}
        </button>
      </footer>
    </div>
  );
});
